class Main{
    constructor(){
        import(/* webpackChunkName: "appmain" */ "./app/App").then(app => {
            new app.InitApp();
        });
    }
}
new Main();
